import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { DollarSign, Menu, X } from "lucide-react";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: "/", label: "HOME" },
    { to: "/apply", label: "APPLY" },
    { to: "/ach", label: "ACH" },
    { to: "/payment", label: "CC PAYMENT" },
    { to: "/business-funding", label: "BUSINESS FUNDING" },
    { to: "https://creditforward360.com", label: "CREDITFORWARD360", external: true },
    { to: "/faq", label: "FAQ" },
    { to: "/become-partner", label: "BECOME A PARTNER" },
    { to: "https://hub.prestigiouscompanies.org/login", label: "PARTNER LOGIN", external: true },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav data-testid="navbar" className="sticky top-0 z-50 bg-[#0a0e1a]/95 backdrop-blur-xl border-b border-slate-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="navbar-logo">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-amber-500 to-amber-400 flex items-center justify-center">
              <DollarSign className="w-4 h-4 text-[#0a0e1a]" strokeWidth={3} />
            </div>
            <span className="text-base font-bold text-white tracking-tight">
              Easy<span className="text-amber-400">Quick</span>Fund
            </span>
          </Link>

          {/* Desktop */}
          <div className="hidden lg:flex items-center gap-0.5">
            {links.map((link) =>
              link.external ? (
                <a
                  key={link.to}
                  href={link.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link px-2.5 py-2 text-xs font-semibold tracking-wide rounded-md transition-colors whitespace-nowrap text-slate-400 hover:text-white"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.to}
                  to={link.to}
                  data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`nav-link px-2.5 py-2 text-xs font-semibold tracking-wide rounded-md transition-colors whitespace-nowrap ${
                    isActive(link.to)
                      ? "text-amber-400"
                      : "text-slate-400 hover:text-white"
                  }`}
                >
                  {link.label}
                </Link>
              )
            )}
            <Link to="/apply" className="ml-3">
              <Button
                data-testid="nav-get-started-btn"
                className="bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-[#0a0e1a] font-bold text-xs cta-gold"
                size="sm"
              >
                GET STARTED
              </Button>
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 rounded-md text-slate-400 hover:text-white hover:bg-slate-800"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div data-testid="mobile-menu" className="lg:hidden pb-4 border-t border-slate-800 mt-2 pt-3">
            {links.map((link) =>
              link.external ? (
                <a
                  key={link.to}
                  href={link.to}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-3 py-2.5 text-sm font-semibold rounded-md text-slate-400 hover:text-white hover:bg-slate-800/50"
                  onClick={() => setMobileOpen(false)}
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`block px-3 py-2.5 text-sm font-semibold rounded-md ${
                    isActive(link.to)
                      ? "text-amber-400 bg-amber-500/5"
                      : "text-slate-400 hover:text-white hover:bg-slate-800/50"
                  }`}
                  onClick={() => setMobileOpen(false)}
                >
                  {link.label}
                </Link>
              )
            )}
            <Link to="/apply" onClick={() => setMobileOpen(false)}>
              <Button
                className="mt-2 w-full bg-gradient-to-r from-amber-500 to-amber-400 text-[#0a0e1a] font-bold"
                size="sm"
              >
                GET STARTED
              </Button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
